import { createReducer, createActions } from 'reduxsauce'

// Initial State
export const initialState = {
    prevLocation: null,
    location: null
}

// Types and Action Creators
const { Types, Creators } = createActions(
    {
        clean: null,
        setLocation: ['location']
        //Async
    },
    {
        prefix: 'SYSTEM_'
    }
)
export const SystemTypes = Types

// Reducers and Handlers
export const handlers = {
    [Types.CLEAN]: () => ({ ...initialState }),
    [Types.SET_LOCATION]: (state = initialState, { location }) => ({
        ...state,
        prevLocation: state.location,
        location
    })
}

export const reducer = createReducer(initialState, handlers)

export default Creators



// WEBPACK FOOTER //
// src/store/redux/routerData.js